<template>
	<div v-if="error" class="text-danger">{{ error }}</div>

	<v-progress-circular left indeterminate size="25" v-else-if="isLoading" />

	<div style="width: 100%" v-else>
		<h5>Choose an agent and set an appointment</h5>
		<p v-if="calendarsListDescription" class="mb-2">{{ calendarsListDescription }}</p>
		<div class="agent-calendars">
			<v-btn
				v-for="(link, idx) in links"
				:key="idx + link.title + link.url"
				:class="isMobile && 'my-1 px-1'"
				color="q_blue_1"
				:loading="isLoading"
				:disabled="!link.url"
				text
				:small="isMobile"
				@click="updateSME(link)"
			>
				<v-icon left>icon-events</v-icon>
				<v-divider class="mx-1" vertical></v-divider>
				{{ isMobile ? link.title : `Open ${link.title}'s Calendar` }}
			</v-btn>
		</div>

		<div class="d-flex flex-wrap justify-end mt-6" style="width: 100%">
            <slot name="try-again" />
		</div>

		<v-dialog v-if="showDialog && selectedSME" v-model="showDialog" max-width="540px">
            <v-card>
                <v-card-title>
                    <p><strong>{{ selectedSME.title }}</strong>'s Calendar</p>
                </v-card-title>
                <v-card-text>
                    <p>Ready to confirm this SME? Clicking <strong>OK</strong> will assign them to your reset and they'll get an email with all the details.</p>
                    <p>You'll have 15 minutes to choose a different SME if needed to accommodate the client's schedule.</p>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="py-4 px-6">
                    <v-btn color="q_blue_1" outlined @click="cancel">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="q_blue_1" depressed @click="setAppointment">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
	</div>
</template>

<script>
import QuilityAPI from "@/store/API/QuilityAPI.js";

export default {
	props: {
		resetPool: { type: String, required: true },
	},

	data() {
		return {
			links: [],
			isLoading: false,
			error: "",
			selectedSME: null,
			resetPoolSet: null,
			showDialog: false,
		}
	},

	mounted() {
		this.loadAppointmentCalendars();
	},

	methods: {
		loadAppointmentCalendars () {
			this.resetPoolSet = null
			this.isLoading = true;
			this.error = "";
			QuilityAPI.getAgentConfigsBaseshopAppointmentCalendar(this.user.AgentCode, this.resetPool)
				.then((response) => {
					this.resetPoolSet = response.meta?.resetPoolSet
					this.links = response.data.map((d) => ({
						title: d.Agent.AgentName,
						url: d.CalendarURL,
						agentCode: d.Agent.AgentCode,
					}));
					if (this.links.length === 0) {
						this.error = "Agents do not have calendar URLs set";
					}
				})
				.catch(() => {
					this.error = "Unable to get agents calendar";
				})
				.finally(() => {
					this.isLoading = false
				})
		},
		cancel () {
			this.selectedSME = null
			this.showDialog = false
		},
		updateSME (sme) {
			this.selectedSME = { ...sme }
			this.showDialog = true
		},
		setAppointment () {
			this.confirmSME(this.selectedSME.title, this.selectedSME.agentCode)
			window.open(this.selectedSME.url, '_blank')
			this.cancel()
		},
		confirmSME (Agent, AgentCode) {
			this.amplitudeTrack('FIF_appointment_confirmed')
			this.$emit("sme-confirmed", { Agent, AgentCode, script: this.resetPool })
		},
	},

	watch: {
		resetPool () {
			this.loadAppointmentCalendars()
			this.selectedSME = null
			this.showDialog = false
		},
		showDialog (val) {
			if (!val) {
				this.selectedSME = null
			}
		},
	},

	computed: {
		isMobile () {
			return this.$vuetify.breakpoint.smAndDown
		},
		calendarsListDescription () {
			if (this.resetPoolSet === null || this.resetPoolSet === undefined) { return '' }
			return this.resetPoolSet
				? `Below is a list of ${this.resetPool} subject matter experts recommended by your Agency Owner.`
				: `Below is a comprehensive list of ${this.resetPool} subject matter experts.`
		},
	},
};
</script>

<style lang="scss">
	.text-danger {
		color: #ff5252;
	}

	.agent-calendars {
		width: 100%;
		max-height: 20rem;
		padding: 0.5rem 0;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		overflow: auto;
	}

	.v-btn.q_blue_1 {
		color: #fff;
	}
</style>
